// Utilitário para limpar cache de notificações
export const clearNotificationCache = () => {
  try {
    localStorage.removeItem('app-notifications');
    console.log('✅ Cache de notificações limpo');
  } catch (error) {
    console.error('❌ Erro ao limpar cache de notificações:', error);
  }
};

// Função para ser chamada no console do navegador
(window as any).clearNotificationCache = clearNotificationCache;
